export default {
  demo: 'demo演示',
  button: '按钮的扩展',
  modal: '可拖拽弹窗',
  form: {
    demo: '表单演示',
    basic: '基础表单',
    rule: '表单校验',
    dynamic: '动态表单',
    customForm: '自定义表单组件',
  },
  table: {
    demo: '表格演示',
    searchTable: '查询表格',
    wzry: '王者荣耀',
    lol: '英雄联盟',
  },
  icon: '自定义图标',
};
